module.exports = __webpack_public_path__ + "media/stairsdown.d03f1e61.mp4";